import { ContentType } from '@/interfaces/campaign';

type platformType = {
  reel?: ContentType;
  post?: ContentType;
  story?: ContentType;
};

export const getUsedPlatforms = (contentType: platformType): string => {
  const platforms = new Set<string>();

  if (contentType?.reel && contentType?.reel?.platform)
    platforms.add(contentType?.reel?.platform);
  if (contentType?.post && contentType?.post?.platform)
    platforms.add(contentType?.post?.platform);
  if (contentType?.story && contentType?.story?.platform)
    platforms.add(contentType?.story?.platform);

  const platformArray = Array.from(platforms);
  if (platformArray.length === 0) {
    return '';
  }

  if (platformArray.length === 1) {
    return platformArray[0];
  }
  if (
    (platformArray.length === 2 &&
      platformArray.includes('instagram') &&
      platformArray.includes('tiktok')) ||
    platformArray.includes('both')
  ) {
    return 'both';
  }
  return platformArray.join(', ');
};

export const getPlatformsByType = (
  contentType: platformType,
): {
  reel: string[];
  post: string[];
  story: string[];
} => {
  const result: { reel: string[]; post: string[]; story: string[] } = {
    reel: [],
    post: [],
    story: [],
  };

  if (contentType?.reel) {
    result.reel = contentType?.reel.platform
      ? [contentType?.reel.platform]
      : [];
  }

  if (contentType?.post) {
    result.post = contentType?.post?.platform
      ? [contentType?.post?.platform]
      : [];
  }

  if (contentType?.story) {
    result.story = contentType?.story?.platform
      ? [contentType?.story.platform]
      : [];
  }

  return result;
};

export const getActivePlatforms = (formData: {
  reelPlatforms?: string[] | null;
  postPlatforms?: string[] | null;
  storyPlatforms?: string[] | null;
}): { instagram: boolean; tiktok: boolean } => {
  const all = [
    ...(formData.reelPlatforms || []),
    ...(formData.postPlatforms || []),
    ...(formData.storyPlatforms || []),
  ];

  return {
    instagram: all.includes('instagram') || all.includes('both'),
    tiktok: all.includes('tiktok') || all.includes('both'),
  };
};
